import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { simulateLoadAction } from '../actions'
import {
  getThumbnails, getScrollPosition, hasPersons, isGalleryLoading,
} from '../selectors'
import GalleryComponent from './GalleryComponent'

const mapStateToProps = state => ({
  loaded: !isGalleryLoading(state) && hasPersons(state),
  persons: getThumbnails(state),
  scrollPosition: getScrollPosition(state),
})

const mapDispatchToProps = dispatch => ({
  scrollToPrevious (scrollPosition) {
    return () => window.scroll({ top: scrollPosition, behavior: 'smooth' })
  },
  loadData () {
    return dispatch(simulateLoadAction())
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  scrollToPrevious: dispatchProps.scrollToPrevious(stateProps.scrollPosition),
})

const Gallery = withRouter(
  connect(
    mapStateToProps, mapDispatchToProps, mergeProps,
  )(GalleryComponent)
)

export default Gallery



// WEBPACK FOOTER //
// ./src/gallery/components/Gallery.js